//special variable provided by MaterialUI to override their default colors
//we use this in app.jsx
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";

const MuiTheme = {
  typography: {
    fontFamily: [
      "Neue Haas Grotesk Display",
      "Inter",
      "Arial",
      "sans-serif",
    ].join(","),
    fontWeight: "400",
    color: "#1D1D45",
    h1: {
      fontFamily: "Neue Haas Grotesk Display",
      fontWeight: 500,
      fontSize: 24,
      "@media (min-width: 900px)": {
        fontSize: 32,
      },
    },
    h2: {
      fontFamily: "Neue Haas Grotesk Display",
      fontWeight: 500,
      fontSize: 20,
      "@media (min-width: 900px)": {
        fontSize: 24,
      },
    },
    h3: {
      fontFamily: "Neue Haas Grotesk Display",
      fontWeight: 500,
      fontSize: 16,
      "@media (min-width: 900px)": {
        fontSize: 18,
      },
    },
    h4: {
      fontFamily: "Neue Haas Grotesk Display",
      fontWeight: 500,
      fontSize: 14,
      "@media (min-width: 900px)": {
        fontSize: 16,
      },
    },
    h5: {
      fontFamily: "Neue Haas Grotesk Display",
      fontWeight: 500,
      fontSize: 12,
      "@media (min-width: 900px)": {
        fontSize: 14,
      },
    },
    h6: {
      fontFamily: "Neue Haas Grotesk Display",
      fontWeight: 500,
      fontSize: 10,
      "@media (min-width: 900px)": {
        fontSize: 12,
      },
    },
    button: {
      fontFamily: "Neue Haas Grotesk Display",
      fontWeight: 500,
      textTransform: "none",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          fontWeight: 500,
          fontSize: 16,
          textTransform: "none",
          padding: "8px 24px",
          boxShadow: "none",
          "&:hover": {
            borderColor: "#4DB05A",
            background: "rgba(255,255,255,0.1) !important",
            backgroundColor: "rgba(255,255,255,0.1) !important",
          },
          "&:focus": {
            outline: "none",
            borderColor: "#4DB05A",
            background: "transparent !important",
            backgroundColor: "transparent !important",
          },
          "&:focus-visible": {
            outline: "none",
            borderColor: "#4DB05A",
            background: "transparent !important",
            backgroundColor: "transparent !important",
          },
          "&.Mui-focusVisible": {
            outline: "none",
            borderColor: "#4DB05A",
            background: "transparent !important",
            backgroundColor: "transparent !important",
          },
        },
        outlined: {
          borderColor: "#ECECEC",
          color: "#242424",
          "&:hover": {
            borderColor: "#4DB05A",
            background: "rgba(255,255,255,0.1) !important",
            backgroundColor: "rgba(255,255,255,0.1) !important",
          },
          "&:focus": {
            outline: "none",
            borderColor: "#4DB05A",
            background: "transparent !important",
            backgroundColor: "transparent !important",
          },
          "&:focus-visible": {
            outline: "none",
            borderColor: "#4DB05A",
            background: "transparent !important",
            backgroundColor: "transparent !important",
          },
          "&.Mui-focusVisible": {
            outline: "none",
            borderColor: "#4DB05A",
            background: "transparent !important",
            backgroundColor: "transparent !important",
          },
        },
        contained: {
          backgroundColor: "#4DB05A",
          "&:hover": {
            backgroundColor: "#399B46 !important",
            background: "#399B46 !important",
          },
          "&:focus": {
            backgroundColor: "#4DB05A !important",
            background: "#4DB05A !important",
          },
          "&:focus-visible": {
            backgroundColor: "#4DB05A !important",
            background: "#4DB05A !important",
          },
          "&.Mui-focusVisible": {
            backgroundColor: "#4DB05A !important",
            background: "#4DB05A !important",
          },
        },
        sizeSmall: {
          padding: "4px 12px",
          fontSize: 14,
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 550,
      md: 768,
      lg: 1200,
      xl: 1536,
    },
  },
};

const primaryButton = {
  height: "40px",
  width: "100%",
  fontWeight: "bold",
  textTransform: "none",
  backgroundColor: "#5C97D5",
  padding: "8px 16px",
  //   border: "1px solid #BD0581",
  color: "white",
  borderRadius: "12px",

  //   boxShadow:
  //     "0px 12px 20px 0px #FD02AA70,0px 4px 4px 0px #00000047,0px 2px 0px 0px #BD0581",

  "&:hover": {
    backgroundColor: "#025277",
  },
};

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 8,
  borderRadius: 10,
  flex: 1,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#ECECEC",
    "@media (prefers-color-scheme: dark)": {
      backgroundColor: theme.palette.grey[800],
    },
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#3CAB5C",
    "@media (prefers-color-scheme: dark)": {
      backgroundColor: "#3CAB5C",
    },
  },
}));

export { primaryButton, MuiTheme, BorderLinearProgress };
